import { Divider, Grid, Typography } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import FormSection from "../../../../common/components/functional/formSection/FormSection";

type Props = {
  endDate?: string;
};

const BasicInfo = ({ endDate }: Props) => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  return (
    <FormSection
      title={t("talentProfile:wtAndTesSpecificSalary")}
      noBorder
      disablePaddingBottom
      margin
    >
      <Grid item textAlign="end" alignSelf="center" xs={4}>
        <Typography color="textSecondary">{t("common:workTitle")}</Typography>
      </Grid>
      <Grid item xs={8}>
        <Controller
          name="workTitle"
          control={control}
          render={({ field }) => <Typography>{field.value.name}</Typography>}
        />
      </Grid>
      <Grid item xs={4} alignSelf="center" textAlign="end">
        <Typography variant="secondary">{t("common:tes")}</Typography>
      </Grid>
      <Grid item xs={8} alignSelf="center">
        <Controller
          name="tes"
          control={control}
          render={({ field }) => <Typography>{field.value.name}</Typography>}
        />
      </Grid>
      {endDate && (
        <>
          <Grid item xs={4} alignSelf="center" textAlign="end">
            <Typography variant="secondary">{t("common:ends")}</Typography>
          </Grid>
          <Grid item xs={8} alignSelf="center">
            <Typography sx={{ color: (theme) => theme.palette.error.main }}>
              {endDate}
            </Typography>
          </Grid>
        </>
      )}
      <Grid item xs={12}>
        <Divider sx={{ margin: "8px 0" }} />
      </Grid>
    </FormSection>
  );
};

export default BasicInfo;
